const AppLoadingShell = ({ label = "Loading Sporthouse" }) => (
  <div className="app-loading-shell" role="status" aria-live="polite" aria-label={label}>
    <div className="app-loading-shell__progress" aria-hidden="true" />
    <span className="sr-only">{label}</span>
  </div>
);

export default AppLoadingShell;
